import {
  SimpleHeader,
  SimpleHeaderWithNavigation,
} from '@/features/shared/components/Headers/SimpleHeader'
import { Footer } from '@/features/shared/components/Footers/Footer'
import { type NextPageWithLayout } from '@/pages/_app'
import { attachLayout } from '@/features/shared/components/Headers/Layouts/attachLayout'

export function withSimpleHeaderLayout<P extends object>(
  Component: NextPageWithLayout<P>,
  { suppressFooter }: { suppressFooter?: boolean } = {},
) {
  return attachLayout(Component, (page) => (
    <>
      <SimpleHeader />
      {page}
      {!suppressFooter && <Footer />}
    </>
  ))
}

export function withSimpleHeaderWithNavigationLayout<P extends object>(
  Component: NextPageWithLayout<P>,
  { suppressFooter }: { suppressFooter?: boolean } = {},
) {
  return attachLayout(Component, (page) => (
    <>
      <SimpleHeaderWithNavigation />
      {page}
      {!suppressFooter && <Footer />}
    </>
  ))
}
